import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolder1"><Path d="M10.4014 3H2V20H22V6H12.4014L10.4014 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder1;
